__turbopack_context__.v({
  "notice": "SwitchWorkspaceNotice-module-scss-module__1nHrta__notice",
});
